<template v-if="dataReadY">
  <div class="row">
    <div class="col-12 col-md-8 col-xxl-6 d-flex justify-content-between">
      <!-- <Header title="Dashboard" link1="Dashboard"></Header> -->
      <h3>Dashboard</h3>
      <div class="d-flex gap-3">
        <div class="form-check form-switch mt-1">
          <input class="form-check-input" type="checkbox" id="dashboardFlexSwitchPublished" v-model="param.published"
            @change="setRouter()">
          <label class="form-check-label" for="dashboardFlexSwitchPublished">Hanya Data Published</label>
        </div>
        <div class="form-check form-switch mt-1">
          <input class="form-check-input" type="checkbox" id="dashboardFlexSwitchCheckDefault" v-model="param.inactive"
            @change="setRouter()">
          <label class="form-check-label" for="dashboardFlexSwitchCheckDefault">Termasuk Siswa Inactive</label>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 col-xxl-6">
      <div class="row">
        <div class="col-6">
          <!-- <label for="">Tahun Ajar:</label> -->
          <select @change="setRouter()" v-model="param.school_year_id" class="d-inline text-primary form-select"
            placeholder="Tahun Ajar">
            <option v-for="sy in schoolYears" :key="sy.school_year_id" :label="sy.name" :value="sy.school_year_id">
            </option>
          </select>
        </div>
        <div class="col-6">
          <!-- <label for="">Kelas :</label> -->
          <select @change="setRouter()" v-model="param.class_id" class="d-inline text-primary form-select"
            placeholder="Kelas">
            <option value="">Semua Kelas</option>
            <option v-for="c in classes" :key="c.class_id" :label="c.name" :value="c.class_id">
            </option>
          </select>
        </div>
      </div>
    </div>
  </div>

  <div class="row pt-2">
    <div class="col-12 col-md-8 col-xxl-6">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-body">
              <BarChart :payment_statistic="payment_statistic"></BarChart>
            </div>
          </div>
        </div>
        <div class="col-md-12 mt-3 mb-3">
          <div class="card">
            <div class="card-body">
              <DetailPayment :param="param"></DetailPayment>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-4 col-xxl-6">
      <div class="row">
        <div class="col-12 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <PaymentPercentage :payment_statistic="payment_statistic"></PaymentPercentage>
            </div>
          </div>
        </div>
        <div class="col-12 col-xxl-6 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <DoughnutChart :payment_statistic="payment_statistic"></DoughnutChart>
            </div>
          </div>
        </div>
        <div class="col-12 col-xxl-6 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <DoughnutChart2 :payment_statistic="payment_statistic"></DoughnutChart2>
            </div>
          </div>
        </div>
        <div class="col-md-12 mb-3">
          <div class="card h-100">
            <div class="card-body">
              <RecentPayment :param="param"></RecentPayment>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script language="ts" src="./scripts/dashboard.ts"></script>
